<div class="rs-order-type-toggle__title">
  {{ 'DELIVERY_METHOD.' + title | translate }}
</div>

<rs-button-segmented-wrapper *ngFor="let isDesktop of [isDesktop$ | async]">
  <ng-container *ngFor="let deliveryMethod of activeDeliveryMethods$ | async">
    <button
      rs-style="segmented"
      [ngClass]="{
        'rs-button--active': deliveryMethod.method === selectedOrderMethod
      }"
      [disabled]="!deliveryMethod.active"
      (click)="changeSelectedOrderType(deliveryMethod.method)"
    >
      <ng-container [ngSwitch]="deliveryMethod.method">
        <ng-container *ngSwitchCase="DeliveryMethod.Curbside">
          <mat-icon *ngIf="isDesktop" [svgIcon]="curbsideIcon"></mat-icon>
          {{ 'SCHEDULE.' + deliveryMethod.method | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="DeliveryMethod.Delivery">
          <mat-icon *ngIf="isDesktop" [svgIcon]="deliveryIcon"></mat-icon>
          {{ 'SCHEDULE.' + deliveryMethod.method | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="DeliveryMethod.Takeout">
          <mat-icon *ngIf="isDesktop" [svgIcon]="takeoutIcon"></mat-icon>
          {{ 'SCHEDULE.' + deliveryMethod.method | translate }}
        </ng-container>
      </ng-container>
    </button>
  </ng-container>
</rs-button-segmented-wrapper>
